import React from "react";
import ButtonIcon from "./ButtonIcon.jsx";

export default function ButtonIconAdditional(props) {
    // Combine component className
    const className = ["button-additional-base"];
    Array.isArray(props.className) && className.push.call(className, props.className);
    typeof props.className === "string" && className.push(props.className);

    return (
        <ButtonIcon
            {...props}
            icon={
                // /public/img/menu-additional-black.svg
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="black">
                    <circle cx="256" cy="256" r="56" />
                    <circle cx="109" cy="256" r="56" />
                    <circle cx="403" cy="256" r="56" />
                </svg>
            }
        />
    );
}
